import React, { useEffect, useRef, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate, useParams } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";

import Icon1 from "../icons/Icon.js";
import Space from "../layout/Space.js";
import SecondaryButton from "../buttons/SecondaryButton.js";

import PrimaryButton from "../buttons/PrimaryButton.js";
import SetupButton from "../buttons/SetupButton.js";
import TextFieldBorderLess from "../textfields/TextFieldBorderLess.js";
import Spinner from "../loading/Spinner.js";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import { useAppContext } from "../config/AppContext.js";
import { useSnackbar } from "notistack";
import TextField2 from "../textfields/TextField2.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import Modal1 from "../modals/Modal1.js";
import {
  sendSmsVerificationCall,
  VerifySmsCodeCall,
} from "../config/ApiCalls.js";
import { gatherDeviceInfo } from "../config/GatheringInfos.js";
import createNewMaster from "../api/create/createNewMaster.js";
import {
  createDoc,
  getDocDataById,
  getDocDataByRef,
  getFlutterTime,
  getOrgDataById,
  listenDocDataByRef,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";

import TimedProgressBar from "../loading/TimedProgressBar.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import { Warning } from "postcss";
import WarningButton from "../buttons/WarningButton.js";
import inviteTeamMembers from "../api/setup/inviteTeamMembers.js";
import { Switch } from "@mui/material";
import stripeSubscriptionManager from "../api/stripe/stripeSubscriptionManager.js";
import { EasySwitch } from "../textfields/EasySwitch.js";
import { updateDoc } from "firebase/firestore";
import { getUsersByOrgRef } from "../models/OrgFunctions.js";
import updateDocApi from "../api/database/updateDocApi.js";
import TextField2T from "../textfields/TextField2T.js";
import { memberRoles } from "../members/MemberManager.js";

function SetupAdmin({ navigateWorkspace }) {
  const { id } = useParams(); // Access the `id` parameter from the URL
  const { currentUser, loading } = useAuth();

  const [userData, setUserData] = useState(null);
  const [steps, setSteps] = useState([]);
  const [step, setStep] = useState(5);
  const [loadingData, setLoadingData] = useState(false);
  const [qualibat_res, setQualibat_res] = useState(null);
  const [value, setValue] = useState(null);
  const [informations, setInformations] = useState(null);
  const [code, setCode] = useState("");
  const [phone, setPhone] = useState("");
  const [engagement, setEngagement] = useState(true);
  const [orgData, setOrgData] = useState(null);
  const [optionsOpen, setOptionsOpen] = useState(false);

  const [members, setMembers] = useState([]);
  const [secure_open, setSecureOpen] = useState(false);
  const [secure_step, setSecureStep] = useState(0);
  const users = [{ email: "dds@gmail.com" }, { email: "dsdds@gmail.com" }];
  const [setup_session, setSetupSession] = useState(null);
  const [payment_loading, setPaymentLoading] = useState(false);

  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    try {
      // Fetch user data by currentUser's ID

      let session = await getDocDataById("setup_session", id);
      let user = await getUserById(session.user_id);
      setUserData(user);
      setSetupSession(session);
      if (session.step) handleChangeStep(session.step);
      listenDocDataByRef(session.ref, handleRefreshSetupSession);

      let org = null;
      try {
        org = await getOrgDataById(user.org_id);
        if (org) {
          handleSetOrgData(org);
          listenDocDataByRef(org.ref, handleRefreshOrgData);
          handleChangeStep(5);
        } else {
          handleChangeStep(0);
        }
      } catch (error) {
        console.error("Error fetching org:", error);
      }
      if (!org) {
        handleChangeStep(0);
      }

      if (members.length === 0) {
        setMembers([
          {
            email: user.email,
            role: {
              value: "operator",
              label: "Opérateur",
            },
            org_admin: true,
          },
        ]);
      }

      let informations = {
        siret: "",
        nom: "",
        adresse: "",
        code_postal: "",
        dirigeant: "",
        ville: "",
        logo: "",
        dob: "",
      };
      setInformations(informations);
    } catch (error) {
      handleClickVariant("Erreur lors de la récupération des données", "error");
      console.error("Error fetching data:", error);
    }
  };

  const handleRefreshSetupSession = async (data) => {
    if (data != setup_session) {
      setSetupSession(data);
      if (data.step) handleChangeStep(data.step);
    }
  };

  const handleSetSetupSession = async (setup_session) => {
    // remove the id field
    setup_session = { ...setup_session };
    delete setup_session.id;

    await updateDocApi(setup_session.ref, setup_session, prefix);
  };

  useEffect(() => {
    if (setup_session) {
      handleSetSetupSession(setup_session);
    }
  }, [setup_session]); // Dependency array ensures this runs when currentUser changes

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  function isDateFormat(date) {
    return /^\d{2}\/\d{2}\/\d{4}$/.test(date);
  }

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleValidateForm = async () => {
    handleChangeStep(3);

    handleClickVariant("Equipe invitée", "success");
  };

  const handleSetOrgData = async (data) => {};

  const handleValidateInformations = () => {
    if (
      informations["dirigeant"] &&
      informations["nom"] &&
      informations["adresse"] &&
      informations["ville"] &&
      informations["code_postal"]
    ) {
      handleChangeStep(2);
      handleClickVariant("Informations validées", "success");
    } else {
      handleClickVariant("Veuillez remplir tous les champs", "error");
    }
  };

  const clientId = Math.random().toString(36).substr(2, 9); // Unique ID for each client
  const wsUrl =
    "https://hexa-websockets-518651086100.europe-west9.run.app/" +
    `ws/${clientId}`; // Adjust if running in production

  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [otherCursors, setOtherCursors] = useState({}); // Store other users' cursors
  const [socket, setSocket] = useState(null);
  const socketRef = useRef(null);
  const [connectedUsers, setConnectedUsers] = useState(0);
  const [operator_count, setOperatorCount] = useState(1);
  const [forever_plan, setForeverPlan] = useState(null);

  useEffect(() => {
    if (!setup_session) return;
    const ws = new WebSocket(wsUrl);

    ws.onopen = () => console.warn("Connected to WebSocket server");

    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (!data) return;
      if (data.type === "update_clients") {
        setConnectedUsers(data.count);
      } else {
        if (
          setup_session &&
          data.position.setupSessionId === setup_session?.id
        ) {
          if (socketRef.current) {
            const { offsetWidth, offsetHeight } = socketRef.current;
            if (data.position.x && data.position.y) {
              setOtherCursors((prev) => ({
                ...prev,
                [data.client_id]: {
                  x: data.position.x * offsetWidth, // Scale back to div size
                  y: data.position.y * offsetHeight, // Scale back to div size
                },
              }));
            }
            handleChangeStep(data.position.step || 0);
            setInformations(data.position.informations || informations);
            setMembers(data.position.members_id || members);
            setSecureOpen(data.position.secure_open || false);
            setPhone(data.position.phone || phone);
            setCode(data.position.code || code);
            setSecureStep(data.position.secure_step || 0);
            setOrgData(data.position.orgData || orgData);
            setEngagement(data.position.engagement || false);
            setPaymentLoading(data.position.payment_loading || false);
            setForeverPlan(data.position.forever_plan || null);
          }
        } else {
          console.warn(
            "Setup session ID received / selected ",
            data.position.setupSessionId,
            setup_session?.id
          );
        }
      }
    };

    ws.onclose = () => console.warn("Disconnected from WebSocket server");

    setSocket(ws);
    return () => ws.close();
  }, [setup_session]);

  const handleChangeStep = (step) => {
    setStep(step);
    getSteps(step);
  };

  const handleSendSms = async () => {
    const infos = gatherDeviceInfo();
    sendSmsVerificationCall("setup", phone, infos, prefix);
    setSecureStep(1);
  };

  const handleCreateOrg = async () => {
    let token = await getOrRefreshFirebaseToken();

    await createNewMaster(
      userData.id,
      informations.nom,
      informations.adresse,
      phone,
      informations.ville,
      informations.code_postal,
      informations.dirigeant,
      informations.siret,

      prefix,
      token
    );

    // invite team
    token = await getOrRefreshFirebaseToken();
    let memberss = members.map((member) => {
      return {
        email: member.email,
        role: member.role.value,
      };
    });

    await inviteTeamMembers(memberss, token, prefix);
    handleClickVariant("Organisation créée", "success");
  };

  const handleCloseModal = () => {
    setSecureOpen(false);
    setSecureStep(0);
  };

  const handleProcessPayment = async () => {
    // Process payment
  };

  const handleRefreshOrgData = async (data) => {
    setOrgData(data);
  };

  useEffect(() => {
    if (
      orgData?.facturation?.restricted === false &&
      ["premium", "business", "starter"].includes(orgData?.facturation?.plan) &&
      userData.email !== "william.bresso@gmail.com"
    ) {
      handleClickVariant("Paiement validé", "success");
      navigateWorkspace("/home");
    }
  }, [orgData]);

  const handlePlanChange = async (plan, engagement) => {
    const token = await getOrRefreshFirebaseToken();
    const url = await stripeSubscriptionManager(
      plan,
      engagement,
      token,
      prefix
    );
    handleClickVariant("Paiement initié", "success");
    // open new window and launch url
    window.open(url, "_blank");
    setPaymentLoading(true);
  };

  const handleAddTrialDays = async (days) => {
    await updateDocDataFieldApi(setup_session.ref, "trial_days", days, prefix);
  };

  const handleSetForeverPlan = async (plan) => {
    await updateDocDataFieldApi(
      setup_session.ref,
      "forever_plan",
      plan,
      prefix
    );
  };

  const handleCheckCode = async () => {
    let res = await VerifySmsCodeCall("setup", phone, code, prefix);
    if (res.success) {
      setSecureOpen(false);
      handleChangeStep(4);
      await handleCreateOrg();
      let user = await getUserById(currentUser.uid);
      let org = await getOrgDataById(user.org_id);
      listenDocDataByRef(org.ref, handleRefreshOrgData);

      handleSetOrgData(org);
      navigateWorkspace("/home");
      window.location.reload();
    } else {
      handleClickVariant("Code SMS incorrect", "error"); // Error notification
      setCode("");
      setPhone("");
    }
  };

  const getSteps = (step) => {
    let steps = [6, 6, 6, 6, 6, 6];
    steps[step] = 100;
    setSteps(steps);
  };

  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  if (loading || !currentUser || !userData) {
    return (
      <div className="w-full h-full overflow-auto flex flex-row gap-2 mt-3">
        {/* Left Column Skeleton */}
      </div>
    );
  }

  return (
    <div className="w-full h-full  flex flex-col p-5 items-center">
      <div
        ref={socketRef}
        className="relative  flex flex-col  w-full h-full p-5 items-center border-3 border-purple-400 rounded-2xl shadow-lg shadow-purple-200"
      >
        <div>
          {connectedUsers === 1 && (
            <div className="text-hx2 text-red-400 font-semibold">
              Personne n'est connecté
            </div>
          )}
        </div>

        <div>
          {/* Render Other Users' Cursors */}
          {Object.entries(otherCursors).map(([id, pos]) =>
            id !== clientId ? (
              <div
                key={id}
                className="z-20"
                style={{
                  position: "absolute",
                  top: pos.y,
                  left: pos.x,
                  width: 0,
                  height: 0,
                  backgroundColor: "transparent",
                  borderRadius: "50%",
                  pointerEvents: "none",
                }}
              >
                <div className=" ">
                  <Icon1 size={25} icon_name="cursor"></Icon1>
                  <div className="text-h3 font-medium  text-violet-400">
                    Utilisateur
                  </div>
                </div>
              </div>
            ) : null
          )}
        </div>
        <div className="absolute top-2 right-2 flex flex-row gap-4 items-center ">
          <div className="w-fit  text-h3 text-violet-500 ">
            {setup_session?.email}
          </div>
          <div className="w-fit  text-h3 text-violet-500 ">
            {new Date(
              setup_session?.last_opened_date?.seconds * 1000
            ).toLocaleString()}
          </div>
          {connectedUsers > 1 && (
            <div className=" h-4 w-4 rounded-full bg-violet-400 "></div>
          )}{" "}
          {connectedUsers === 1 && (
            <div className=" h-4 w-4 rounded-full bg-red-400 "></div>
          )}
        </div>
        <div className="absolute top-8 right-2 bg-purple-200 rounded-lg p-2 flex flex-col gap-1 items-end ">
          <SecondaryButton onClick={() => setOptionsOpen(!optionsOpen)}>
            Options
          </SecondaryButton>
          {optionsOpen && (
            <div className="flex flex-col gap-1">
              <SecondaryButton
                disabled={
                  !setup_session?.trial_days || setup_session?.trial_days === 0
                }
                onClick={() => handleAddTrialDays(0)}
              >
                Désactiver les jours d'essai
              </SecondaryButton>
              <SecondaryButton
                disabled={
                  setup_session?.trial_days === 7 || setup_session.forever_plan
                }
                onClick={() => handleAddTrialDays(7)}
              >
                Option 7 jours d'essai
              </SecondaryButton>
              <SecondaryButton
                disabled={
                  setup_session?.trial_days === 30 || setup_session.forever_plan
                }
                onClick={() => handleAddTrialDays(30)}
              >
                Option 30 jours d'essai
              </SecondaryButton>
              <Space y={10} />
              <SecondaryButton
                disabled={setup_session?.forever_plan === null}
                onClick={() => handleSetForeverPlan(null)}
              >
                Abonnements classiques
              </SecondaryButton>
              <SecondaryButton
                disabled={setup_session?.forever_plan === "high"}
                onClick={() => handleSetForeverPlan("high")}
              >
                Option Offre unique ambassadeur 2800€
              </SecondaryButton>
              <SecondaryButton
                disabled={setup_session?.forever_plan === "medium"}
                onClick={() => handleSetForeverPlan("medium")}
              >
                Option Offre unique ambassadeur 1500€
              </SecondaryButton>
              <SecondaryButton
                disabled={setup_session?.forever_plan === "low"}
                onClick={() => handleSetForeverPlan("low")}
              >
                Option Offre unique ambassadeur 1000€
              </SecondaryButton>
            </div>
          )}
        </div>
        <Modal1 isOpen={secure_open} onClose={handleCloseModal}>
          <div className="bg-white rounded-3xl w-c300 flex flex-col p-4 gap-2">
            {secure_step === 0 && (
              <>
                <div className="text-h2"> Entrez votre numéro de téléphone</div>
                <TextField2T
                  label="Téléphone"
                  type="phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                ></TextField2T>
                <div className="flex flex-row gap-2 items-center">
                  <SecondaryButton onClick={handleCloseModal}>
                    Annuler
                  </SecondaryButton>
                  <PrimaryButton onClick={handleSendSms} className="flex-grow">
                    Envoyer code SMS
                  </PrimaryButton>
                </div>
              </>
            )}
            {secure_step === 1 && (
              <>
                <div className="text-h2"> Entrez le code reçu par SMS</div>
                <TextField2
                  label="Code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                ></TextField2>
                <div className="flex flex-row gap-2 items-center">
                  <PrimaryButton
                    onClick={handleCheckCode}
                    className="flex-grow"
                  >
                    Vérifier
                  </PrimaryButton>
                </div>
              </>
            )}
          </div>
        </Modal1>
        {/* Left Column: Takes all available space */}
        {true && (
          <>
            <div className="flex flex-row w-full items-start">
              <div className="flex flex-row border-1 border-shadow_10 rounded-full shadow-md gap-2 w-fit p-2">
                {steps.map((step, index) => (
                  <div
                    key={index}
                    className=" bg-black rounded-full"
                    style={{ width: `${step}px`, height: "6px" }}
                  ></div>
                ))}
              </div>
            </div>
            <Space y={15} />
            {step !== 0 && step !== 5 && (
              <div className="flex flex-row w-full items-start">
                <div
                  className="flex flex-row border-1 border-shadow_25 rounded-full text-shadow_50 text-h2 gap-2 w-fit px-2 cursor-pointer"
                  onClick={() => handleChangeStep(step - 1)}
                >
                  Retour
                </div>
              </div>
            )}
            {setup_session?.trial_days > 0 && (
              <div className="flex flex-row mt-2 w-full items-start">
                <div className="flex flex-row bg-teal-100 text-green-600 rounded-full  text-h2 gap-2 w-fit px-2 cursor-pointer">
                  {setup_session.trial_days} jours d'essai offerts
                </div>
              </div>
            )}
            {setup_session?.forever_plan && (
              <div className="flex flex-row mt-2 w-full items-start">
                <div className="flex flex-row bg-teal-100 text-green-600 rounded-full  text-h2 gap-2 w-fit px-2 cursor-pointer">
                  Offre unique ambassadeur
                </div>
              </div>
            )}
          </>
        )}
        <div className="flex flex-col h-full  justify-center">
          {step === 0 && (
            <div className="bg-white rounded-3xl p-4 w-c600  shadow-xl flex flex-col">
              <div className="text-hx3 font-semibold text-center">Bonjour</div>{" "}
              <Space y={10} />
              <img
                src="https://picsum.photos/seed/816/600"
                className="object-cover w-full h-c300 object-top     rounded-3xl      
            "
              ></img>{" "}
              <Space y={10} />
              <div className="text-h3 text-shadow_50 text-center">
                Durée setup - 3 min
              </div>
              <Space y={10} />
              <div className="items-center w-full justify-center flex flex-row gap-2">
                {" "}
                <SetupButton
                  onClick={() => handleChangeStep(1)}
                  className="w-fit"
                >
                  Continuer
                </SetupButton>
              </div>
            </div>
          )}

          {step === 1 && (
            <div className="bg-white rounded-3xl p-4 w-fit  shadow-xl flex flex-col">
              <div className="flex flex-col items-center">
                <div className="flex flex-row gap-2 items-center w-full justify-center">
                  <div className="text-hx font-semibold text-center">
                    Informations
                  </div>{" "}
                </div>
                <Space y={10} />
                <div className="text-h3 text-shadow_50 text-center w-c250">
                  Entrez les informations manquantes de votre entreprise
                  ci-dessous
                </div>
                <Space y={20} />
                <div className="flex flex-col gap-3 w-full">
                  <TextField2
                    label="Prénom Nom"
                    value={informations["dirigeant"]}
                    onChange={(e) =>
                      setInformations({
                        ...informations,
                        dirigeant: e.target.value,
                      })
                    }
                  ></TextField2>

                  <TextField2
                    label="Entreprise"
                    value={informations["nom"]}
                    onChange={(e) =>
                      setInformations({
                        ...informations,
                        nom: e.target.value,
                      })
                    }
                  ></TextField2>
                  <TextField2
                    label="Adresse"
                    value={informations["adresse"]}
                    onChange={(e) =>
                      setInformations({
                        ...informations,
                        adresse: e.target.value,
                      })
                    }
                  ></TextField2>
                  <TextField2
                    label="Ville"
                    value={informations["ville"]}
                    onChange={(e) =>
                      setInformations({
                        ...informations,
                        ville: e.target.value,
                      })
                    }
                  ></TextField2>
                  <TextField2
                    label="Code Postal"
                    value={informations["code_postal"]}
                    onChange={(e) =>
                      setInformations({
                        ...informations,
                        code_postal: e.target.value,
                      })
                    }
                  ></TextField2>
                </div>

                <Space y={20} />

                <div className="items-center w-full justify-center flex flex-row gap-2">
                  {" "}
                  <SetupButton
                    onClick={handleValidateInformations}
                    className="w-fit"
                  >
                    Continuer
                  </SetupButton>
                </div>
              </div>
            </div>
          )}
          {step === 2 && (
            <div className="bg-white rounded-3xl p-4 w-fit  shadow-xl flex flex-col">
              <div className="flex flex-col items-center">
                <div className="flex flex-row gap-2 items-center w-full justify-center">
                  <div className="text-hx font-semibold text-center">
                    Votre équipe
                  </div>{" "}
                </div>
                <Space y={20} />
                <div className="text-h1 text-shadow_50 text-center">
                  Invitez votre équipe
                </div>{" "}
                <Space y={20} />
                <div className="flex flex-col gap-2 items-start">
                  {members.map((member, index) => (
                    <div
                      key={index}
                      className="flex flex-row gap-2  w-c700 items-center"
                    >
                      <TextField2
                        className="max-w-c300"
                        value={member.email}
                        disabled={userData.email === member.email}
                        onChange={(e) =>
                          setMembers(
                            members.map((m, i) => {
                              if (i === index) {
                                return { ...m, email: e.target.value };
                              }
                              return m;
                            })
                          )
                        }
                      ></TextField2>
                      <DropDownGPT0
                        value={member.role}
                        className="w-c250"
                        items={memberRoles}
                        disabled={userData.email === member.email}
                        onChange={(e) =>
                          setMembers(
                            members.map((m, i) => {
                              if (i === index) {
                                return { ...m, role: e };
                              }
                              return m;
                            })
                          )
                        }
                      ></DropDownGPT0>

                      {userData.email !== member.email && (
                        <>
                          <WarningButton
                            onClick={() =>
                              setMembers(members.filter((m, i) => i !== index))
                            }
                          >
                            Supprimer
                          </WarningButton>
                        </>
                      )}
                    </div>
                  ))}
                  <Space y={10} />
                  <PrimaryButton
                    onClick={() =>
                      setMembers([...members_id, { email: "", role: null }])
                    }
                  >
                    Ajouter un membre
                  </PrimaryButton>{" "}
                </div>
                <Space y={20} />
                <div className="items-center w-full justify-center flex flex-row gap-2">
                  {" "}
                  <SetupButton onClick={handleValidateForm} className="w-fit">
                    Continuer
                  </SetupButton>
                </div>
              </div>
            </div>
          )}
          {step === 3 && (
            <div className="bg-white rounded-3xl p-4 w-fit  shadow-xl flex flex-col">
              <div className="flex flex-col items-center">
                <div className="flex flex-row gap-2 items-center w-full justify-center">
                  <div className="text-hx font-semibold text-center">
                    Sécurité
                  </div>{" "}
                </div>
                <Space y={20} />
                <div className="text-h3 text-shadow_50 w-c250 text-center">
                  Suivez la procédure pour sécuriser votre compte avec votre
                  numéro de téléphone
                </div>

                <Space y={20} />

                <div className="items-center w-full justify-center flex flex-row gap-2">
                  {" "}
                  <SetupButton
                    onClick={() => setSecureOpen(true)}
                    className="w-fit flex flex-row items-center gap-2"
                  >
                    {" "}
                    <Icon1
                      icon_name="clé"
                      fill="#fff"
                      height="20px"
                      width="20px"
                    ></Icon1>
                    Sécuriser
                  </SetupButton>
                </div>
              </div>
            </div>
          )}

          {step === 4 && (
            <div className="bg-white rounded-3xl p-4 w-fit  shadow-xl flex flex-col">
              <div className="flex flex-col items-center">
                <div className="flex flex-row gap-2 items-center w-full justify-center">
                  <div className="text-hx font-semibold text-center">
                    Création
                  </div>{" "}
                </div>{" "}
                <Space y={10} />
                <div className="w-c200">
                  {" "}
                  <TimedProgressBar />
                </div>
                <Space y={10} />
                <div className="text-h3 text-shadow_50 w-c250 text-center">
                  Entreprise en cours de création ...
                </div>
              </div>
            </div>
          )}
        </div>
      </div>{" "}
    </div>
  );
}

export default SetupAdmin;
